import React, { useEffect } from 'react';
import { initHeader } from '../js/layouts/header';
import Header from './Header';
import Footer from './Footer';

const MainLayout = ({ children }) => {
  useEffect(() => {
    initHeader();
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="main-wrapper">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout; 